/* tslint:disable */
import {
  Report,
  Institutions
} from '../index';

declare var Object: any;
export interface ReportCommentInterface {
  "institution_id"?: number;
  "message": string;
  "report_id": number;
  "author"?: string;
  "sent_at"?: Date;
  "sf_case_work_log_id"?: string;
  "id"?: number;
  report?: Report;
  institution?: Institutions;
}

export class ReportComment implements ReportCommentInterface {
  "institution_id": number;
  "message": string;
  "report_id": number;
  "author": string;
  "sent_at": Date;
  "sf_case_work_log_id": string;
  "id": number;
  report: Report;
  institution: Institutions;
  constructor(data?: ReportCommentInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ReportComment`.
   */
  public static getModelName() {
    return "ReportComment";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ReportComment for dynamic purposes.
  **/
  public static factory(data: ReportCommentInterface): ReportComment{
    return new ReportComment(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ReportComment',
      plural: 'ReportComments',
      path: 'ReportComments',
      properties: {
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "message": {
          name: 'message',
          type: 'string'
        },
        "report_id": {
          name: 'report_id',
          type: 'number'
        },
        "author": {
          name: 'author',
          type: 'string'
        },
        "sent_at": {
          name: 'sent_at',
          type: 'Date'
        },
        "sf_case_work_log_id": {
          name: 'sf_case_work_log_id',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        report: {
          name: 'report',
          type: 'Report',
          model: 'Report'
        },
        institution: {
          name: 'institution',
          type: 'Institutions',
          model: 'Institutions'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/ReportComment.ts